import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from 'redux-store';
import type { PurchaseType } from 'redux-store/slices/purchases/types';

export const getPurchasesSelector = (state: AppState): PurchaseType[] =>
  state.purchases.purchases.slice().sort((b, a) => {
    const aDate = new Date(a.first_pay);
    const bDate = new Date(b.first_pay);

    return +aDate - +bDate;
  });

export const getPurchaseByProductIdSelector = createSelector(
  getPurchasesSelector,
  (_: AppState, id: number) => id,
  (purchases, id): PurchaseType | null => {
    return (
      purchases.find(
        item => item.payment_plan.welltory_payment_plan_id === id,
      ) || null
    );
  },
);
